import argentina from '../assets/flags/argentina.webp'
import chile from '../assets/flags/chile.webp'
import colombia from '../assets/flags/colombia.webp'
import ecuador from '../assets/flags/ecuador.webp'
import guatemala from '../assets/flags/guatemala.webp'
import mexico from '../assets/flags/mexico.webp'
import panama from '../assets/flags/panama.webp'
import paraguay from '../assets/flags/paraguay.webp'
import peru from '../assets/flags/peru.webp'
import venezuela from '../assets/flags/venezuela.webp'
import poster_1 from '../assets/referral/poster_1.webp'
import ec_poster_1 from '../assets/referral/ec_poster_1.webp'
import py_poster_1 from '../assets/referral/py_poster_1.webp'
import poster_2 from '../assets/referral/poster_2.webp'
import poster_3 from '../assets/referral/poster_3.webp'
import type { UserInfo } from '../types/user'
import { COUNTRY_CODE } from './config'
import { AR, CL, CO, EC, GT, MX, PA, PE, PY, VE } from './regions-and-cities'

export type CountryCode =
  | 'AR'
  | 'CL'
  | 'CO'
  | 'EC'
  | 'GT'
  | 'MX'
  | 'PA'
  | 'PE'
  | 'PY'
  | 'VE'

export type MXStates = { id: string; label: string }[]

export type RegionsAndCities = { [key: string]: string[] }

export type SocialLinks = 'tg' | 'ig' | 'fb' | 'x' | 'tiktok' | 'yt'

type CountryInfo = {
  name: string
  zhName: string
  email: string
  flag: string
  addresses: MXStates | RegionsAndCities
  phoneCountryCode: string
  currency: string
  forms: {
    phoneLength: number
    postalCodeLength?: number
    bankNoMaxLength: number
    ruc?: {
      length?: number
      placeholder: string
    }
  }
  gift?: number
  referralProgram?: {
    amount?: string
    timezone?: string
  }
  domain?: string
  socialLinks?: Partial<Record<SocialLinks, string>>
  promoCodeId?: number
  vipSystemId?: number
  randomNumber?: {
    min: number,
    max: number,
  }
  posters?: string[]
  amountSign?: string
  bonusPromoIds?: Record<string, string>
  vipMaxBet?: Record<string, number>
  earnUpTo?: number
  idDocument?: {
    field: keyof UserInfo
    label: string
    placeholder: string
    minLength?: number
    maxLength: number
  }
}

const COUNTRIES: Record<CountryCode, CountryInfo> = {
  AR: {
    name: 'Argentina',
    zhName: '阿根廷',
    email: 'soporte.ar@fun88.com',
    flag: argentina,
    addresses: AR,
    phoneCountryCode: '+54',
    currency: 'ARS',
    forms: {
      phoneLength: 10,
      bankNoMaxLength: 22,
    },
    referralProgram: {
      timezone: '-3',
      amount: '$10,000',
    },
    promoCodeId: 355,
    posters: [poster_1, poster_2, poster_3],
    socialLinks: {
      tg: 'https://t.me/+FJ9Z37hMNhplMTMx',
      ig: 'https://www.instagram.com/fun88argentina?igsh=MWRrM280cXU4cm9lNQ==',
      fb: 'https://www.facebook.com/profile.php?id=61580144557705',
      x: 'https://x.com/Fun88Argentina?t=W-pY2x_xSMr7xN8yaJ5F0A&s=09',
      tiktok: 'https://tiktok.com/@fun88argentina',
      yt: 'https://youtube.com/@fun88ar?si=XEY8DLIdJ_a8cC64',
    },
    vipSystemId: 365,
    idDocument: { field: 'dni', label: 'DNI', placeholder: '12345678', maxLength: 10 },
  },
  CL: {
    name: 'Chile',
    zhName: '智利',
    email: 'soporte.cl@fun88.com',
    flag: chile,
    addresses: CL,
    phoneCountryCode: '+56',
    currency: 'CLP',
    forms: {
      phoneLength: 9,
      postalCodeLength: 7,
      bankNoMaxLength: 20,
    },
    referralProgram: {
      amount: '$10,000',
      timezone: '-4',
    },
    posters: [poster_1, poster_2, poster_3],
    domain: 'fun88.cl',
    socialLinks: {
      tg: 'https://t.me/FUN88_Chile',
      ig: 'https://www.instagram.com/fun88cl',
      fb: 'https://www.facebook.com/profile.php?id=61575712636918#',
      x: 'https://x.com/fun88chile1',
      tiktok: 'https://www.tiktok.com/@fun88cl',
      yt: 'https://m.youtube.com/channel/UCga_syeC079JvrRNI5F0PvQ?fbclid=PAT01DUAM0bbZleHRuA2FlbQIxMAABp_hOSbzr7FPDRAddGOwcbeosyuDrS1zGJB6b62rXUsXcJGUQqwyE1nJ_mUpd_aem_eVtqbF-HLRaaH7ml9OaR4g',
    },
    promoCodeId: 364,
    vipSystemId: 375,
    idDocument: { field: 'rut', label: 'RUT', placeholder: '12345678-5', maxLength: 10 },
  },
  CO: {
    name: 'Colombia',
    zhName: '哥伦比亚',
    email: 'soporte@fun88colombia.com',
    flag: colombia,
    addresses: CO,
    phoneCountryCode: '+57',
    currency: 'COP',
    forms: {
      phoneLength: 12,
      postalCodeLength: 6,
      bankNoMaxLength: 16,
    },
  },
  EC: {
    name: 'Ecuador',
    zhName: '厄瓜多尔',
    email: 'soporte.ec@fun88.com',
    flag: ecuador,
    addresses: EC,
    phoneCountryCode: '+593',
    currency: 'USD',
    forms: {
      phoneLength: 9,
      postalCodeLength: 6,
      bankNoMaxLength: 20,
    },
    gift: 5,
    referralProgram: {
      amount: '$10',
      timezone: '-5',
    },
    earnUpTo: 55,
    posters: [ec_poster_1, poster_2, poster_3],
    promoCodeId: 31,
    vipSystemId: 37,
    bonusPromoIds: {
      rescue_bonus: '16-bono-de-reembolso',
      birthday: '17-bono-anual-de-cumpleaero',
      free_game: '18-juego-gratis',
    },
    idDocument: { field: 'nui', label: 'NUI', placeholder: '1234567890', maxLength: 10 },
  },
  GT: {
    name: 'Guatemala',
    zhName: '危地马拉',
    email: 'soporte@fun88guatemala.com',
    flag: guatemala,
    addresses: GT,
    phoneCountryCode: '+502',
    currency: 'GTQ',
    forms: {
      phoneLength: 8,
      postalCodeLength: 5,
      bankNoMaxLength: 20,
    },
  },
  MX: {
    name: 'Mexico',
    zhName: '墨西哥',
    email: 'soporte@fun88.mx',
    flag: mexico,
    addresses: MX,
    phoneCountryCode: '+52',
    currency: 'MXN',
    gift: 50,
    forms: {
      phoneLength: 10,
      postalCodeLength: 5,
      bankNoMaxLength: 18,
    },
    domain: 'fun88mx.mx',
    idDocument: { field: 'curp', label: 'CURP', placeholder: 'CURP', maxLength: 18 },
  },
  PA: {
    name: 'Panama',
    zhName: '巴拿马',
    email: 'soporte@fun88panama.com',
    flag: panama,
    addresses: PA,
    phoneCountryCode: '+507',
    currency: 'PAB',
    forms: {
      phoneLength: 8,
      bankNoMaxLength: 20,
      ruc: {
        length: 13,
        placeholder: '1-234-567, 1-234-567-89, 1-234-5678-90',
      },
      postalCodeLength: 4,
    },
  },
  PE: {
    name: 'Peru',
    zhName: '秘鲁',
    email: 'soporte@fun88peru.com',
    flag: peru,
    addresses: PE,
    phoneCountryCode: '+51',
    currency: 'PEN',
    forms: {
      phoneLength: 9,
      postalCodeLength: 5,
      bankNoMaxLength: 20,
      ruc: {
        length: 11,
        placeholder: '10456789012',
      },
    },
    socialLinks: {
      tg: '',
      ig: 'https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Ffun88.peru%2F&is_from_rle',
      fb: 'https://www.facebook.com/profile.php?id=61577261231078',
      x: 'https://x.com/FUN88PE',
      tiktok: 'https://www.tiktok.com/@fun88peru?_t=zm-8zkr1lpjlx6&_r=1',
      yt: 'https://www.youtube.com/@FUN88_Per%C3%BA',
    },
  },
  PY: {
    name: 'Paraguay',
    zhName: '巴拉圭',
    email: 'soporte.py@fun88.com',
    flag: paraguay,
    addresses: PY,
    phoneCountryCode: '+595',
    currency: 'PYG',
    forms: {
      phoneLength: 9,
      postalCodeLength: 4,
      bankNoMaxLength: 20,
    },
    referralProgram: {
      timezone: '-3',
      amount: '₲20,000',
    },
    socialLinks: {
      tg: 'https://t.me/FUN88PARAGUAY',
      ig: 'https://www.instagram.com/fun88paraguayoficial?igsh=ZDhhcmo1OW40NDdl',
      fb: 'https://www.facebook.com/share/18wjGMsjcR/',
      x: 'https://x.com/FUN88PARAGUAYOF?t=f-1Nd98D8RlJu_rluIlFtA&s=35',
      tiktok: 'https://www.tiktok.com/@fun88par?_t=ZM-8zhtnmsMMLd&_r=1',
      yt: 'https://www.youtube.com/@FUN88Paraguay',
    },
    randomNumber: {
      min: 5000000,
      max: 10000000,
    },
    posters: [py_poster_1, poster_2, poster_3],
    amountSign: '₲',
    promoCodeId: 32,
    bonusPromoIds: {
      rescue_bonus: '16-bono-de-reembolso',
      birthday: '17-bono-anual-de-cumpleaero',
      free_game: '18-juego-gratis',
    },
    vipSystemId: 36,
    idDocument: { field: 'cedula', label: 'Cédula', placeholder: '12345678', minLength: 6, maxLength: 8 },
  },
  VE: {
    name: 'Venezuela',
    zhName: '委内瑞拉',
    email: 'soporte@fun88venezuela.com',
    flag: venezuela,
    addresses: VE,
    phoneCountryCode: '+58',
    currency: 'VES',
    forms: {
      phoneLength: 9,
      postalCodeLength: 4,
      bankNoMaxLength: 20,
    },
  },
}

const countryMeta = (countryName: string) => {
  if (COUNTRY_CODE === 'MX') {
    return {
      meta: {
        title: `Casino Online en ${countryName}, Apuestas Deportivas en Vivo | FUN88`,
        description: `FUN88 ${countryName}: el mejor casino online con los retiros más rápidos ⚡️ Disfruta 50% de bono de bienvenida, giros gratis y apuestas deportivas en vivo. Juega tragamonedas, blackjack, ruleta y casino en vivo en una plataforma segura y confiable.`,
      },
    }
  }

  return {
    meta: {
      title: `Los mejores casinos online y apuestas deportivas en ${countryName} | Apuestas en vivo con Fun88`,
      description: `FUN88 ${countryName}: el mejor casino online con los retiros más rápidos ⚡️ Disfruta 50% de bono de bienvenida, giros gratis y apuestas deportivas en vivo. Juega tragamonedas, blackjack, ruleta y casino en vivo en una plataforma segura y confiable.`,
    },
  }
}

/**
 * Exporting current country data
 */
export const COUNTRY = {
  ...COUNTRIES[COUNTRY_CODE],
  ...countryMeta(COUNTRIES[COUNTRY_CODE].name),
}

/**
 * Check current country
 *
 * @param code - Country code:
 * - 'AR' = Argentina
 * - 'CL' = Chile
 * - 'EC' = Ecuador
 * - 'GT' = Guatemala
 * - 'MX' = Mexico
 * - 'PA' = Panama
 * - 'PY' = Paraguay
 */
export const IS_COUNTRY: Record<CountryCode, boolean> = {
  AR: COUNTRY_CODE === 'AR',
  CL: COUNTRY_CODE === 'CL',
  CO: COUNTRY_CODE === 'CO',
  EC: COUNTRY_CODE === 'EC',
  GT: COUNTRY_CODE === 'GT',
  MX: COUNTRY_CODE === 'MX',
  PA: COUNTRY_CODE === 'PA',
  PE: COUNTRY_CODE === 'PE',
  PY: COUNTRY_CODE === 'PY',
  VE: COUNTRY_CODE === 'VE',
}

/**
 * Verify whether the argument includes the current country code.
 *
 * @param countries array of country codes
 * @returns true | false
 */
export const countryIncludes = (countries: CountryCode[] = []) =>
  countries.includes(COUNTRY_CODE)
